export default {
  disabled: ["job_id", "created_time", "modified_time", "owner_id"],
  pop_up: ["product_id", "argo_id"],
  required: ["job_name", "argo_id", "product_id", "desc", "class_path"],
};
